import { gql } from "graphql-tag";
import { IP_FIELDS, PAGINATION } from "./Fragments";

export const GET_IP = gql`

    query GetIp($page: Int, $limit: Int) {
        get_ip(limit:$limit, page:$page){
            ...Pagination
            data {
                ...IpFields
            }
        }
    }
    ${IP_FIELDS},
    ${PAGINATION},

`;

export const SEARCH_IP = gql`

    query SearchIp($page: Int, $limit: Int, $search_key: String, $locale:String  , $type:String , $date_from:String , $date_to:String) {
        search_ip(limit:$limit, page:$page, search_key:$search_key, locale:$locale , type:$type , date_from:$date_from , date_to:$date_to){
            ...Pagination
            data {
                ...IpFields
            }
        }
    }
    ${IP_FIELDS},
    ${PAGINATION},

`;

export default { GET_IP, SEARCH_IP };
